<p-scroller class="w-full mt-4  flex flex-column gap-2" [items]="notifications" [appendOnly]="true"
[itemSize]="75" [showLoader]="true" [delay]="50" [loading]="lazyLoading" [lazy]="true"
(onLazyLoad)="onLazyLoad($event)" scrollHeight="250px">
<ng-template pTemplate="item" let-item let-index let-options="options">
  <div *ngIf="item" class="w-full" style="min-height: 75px;">
    <a [routerLink]="getRoute(item) ? getRoute(item) : null" class="w-full block hover:text-blue-700 pb-3 cursor-pointer" style="color: #12263F;">
      <ul class="flex w-full align-items-start gap-2">
        <li class="flex-shrink-0" style="width: 8px; height: 8px;">
          <span class="border-circle bg-blue-100 block"
            style="width: 8px; height: 8px; margin: 5px 0 0 0;"></span>
        </li>
        <li class="w-full flex flex-column gap-2">
          <b class="block w-full font-medium text-left"
            style="font-size: 16px; letter-spacing: -.25px;">
            <ng-container *ngIf="item?.data?.['StudentName'] || item?.data?.['studentName'] || item?.data?.['SenderName'] || item?.data?.['senderName'] || item?.data?.['name'] || item?.data?.['Name'] as studentName">
              {{ studentName }} - 
            </ng-container>
            {{item?.message??''}}
          </b>
          <span class="block w-full text-left" style="font-size: 13px; color: #505050;">
            {{item.createdOn | timeAgo}}
          </span>
        </li>
      </ul>
    </a>
  </div>
</ng-template>
</p-scroller>
